import * as React from 'react';
import { connect } from 'react-redux';
import { Layout, Row, Col, Card } from 'antd';
import VendorForm from '../vendor_form/VendorForm';

const { Content } = Layout;

class NewVendorPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const { history } = this.props;
		return (
			<Content>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card>
							<div>
								<h5 style={{ marginBottom: 24 }}>New Vendor</h5>
								<VendorForm
									formData={{}}
									onSuccess={(rec) => history.push(`/supplier/vendors/detail/${rec.id}`)}
								/>
							</div>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NewVendorPage);
